export const variablesPlans = [
  {
    id: 0,
    name: "Arcade",
    priceMonth: 9,
    priceYear: 90,
    url: "/images/icon-arcade.svg",
  },
  {
    id: 1,
    name: "Advanced",
    priceMonth: 12,
    priceYear: 120,
    url: "/images/icon-advanced.svg",
  },
  {
    id: 2,
    name: "Pro",
    priceMonth: 15,
    priceYear: 150,
    url: "/images/icon-pro.svg",
  },
];

export const variablesAddOns = [
  {
    id: 0,
    name: "Online service",
    description: "Access to multiplayer games",
    priceMonth: 1,
    priceYear: 10,
    promotion: "2 months free",
  },
  {
    id: 1,
    name: "Larger storage",
    description: "Extra 1TB of cloud save",
    priceMonth: 2,
    priceYear: 20,
    promotion: "2 months free",
  },
  {
    id: 2,
    name: "Customizable Profile",
    description: "Custom theme on your profile",
    priceMonth: 2,
    priceYear: 20,
    promotion: "2 months free",
  },
];
